// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';

import classNames from 'classnames';
import styles from './styles';

class Faq extends Component {
  state = {
    open: false,
  };

  static propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    text: PropTypes.string,
  };

  static defaultProps = {
    classes: {},
    title: 'Where is question?',
    text: 'No answer',
  };

  onClick = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  }

  render() {
    const { classes, title, text } = this.props;
    const { open } = this.state;

    return (
      <div className={classes.mainContainer}>
        <div
          role={'button'}
          className={classNames(classes.questionContainer, open ? classes.openBackground : null)}
          onClick={this.onClick}
          onKeyPress={this.onClick}
          tabIndex={'0'}
        >
          <span>{title}</span>
          {open ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </div>
        {open && <span className={classes.answer}>{text}</span>}
      </div>
    );
  }
}

export default withStyles(styles)(Faq);
